
import * as vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      focus: false,
      dropdownOpen: false,

      options: [
        {
          name: "name",
          label: "Naziv opcije",
          type: "text",
        },
        {
          name: "id",
          label: "id",
          type: "text",
        },
      ],
    };
  },
  props: {
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: "label",
    },
    required: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, Object],
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    textarea: {
      type: Boolean,
      default: false,
    },
    customForm: {
      type: Boolean,
      default: false,
    },
    listName: {
      type: String,
      default: "options",
    },
    inputId: {
      type: String,
      required: true,
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
